export default __webpack_public_path__ + "static/media/x_red.f0379d61.svg";